import React, { useState } from 'react';

const DropdownSelector = ({options,key="id",value="name",selectedKey,disabled,changeHandler}) => {

    const [dropdownVisible,setDropdownVisible] = useState(false)

    if( !Array.isArray(options) || typeof selectedKey === 'undefined' ){
        return(<div>...</div>)
    }

    const buttons = options.map( obj => {
        return(
            // eslint-disable-next-line
            <a className="dropdown-item" href="#" key={obj[key]} onClick={ () => {setDropdownVisible(false); changeHandler(obj)} }>{obj[value]}</a>
        )
    })

    const selected = options.filter( o => o[key] === selectedKey ) 

    return(
        <div className="btn-group" role="group" aria-label="Select period">
            <div className="btn-group" role="group" aria-label="Select period">
                <button 
                    id="yearButtonGroup" 
                    type="button" 
                    className="btn btn-outline-secondary dropdown-toggle" 
                    aria-haspopup="true" 
                    aria-expanded="false"
                    onClick={(e) => {e.preventDefault(); setDropdownVisible(!dropdownVisible);}}
                    disabled={disabled}>
                    {selected.length > 0 ? selected[0].name : "..."}
                </button>
                <div className="dropdown-menu" aria-labelledby="Select Year" style={{display: dropdownVisible ? "block" : "none"}}>
                    {buttons}
                </div>
            </div>
        </div>
    );

}

export default DropdownSelector;